module.exports = __webpack_public_path__ + "img/coupon_51.20378409.png";